// Init
import React from 'react';

// Importing Components
import Header from '../components/Header';
import HorizontalLinearStepper from '../components/StepFormContainer';
// Home Component
export default function Home() {
  return (
    <div>
      <HorizontalLinearStepper />
    </div>
  );
}
